import { api } from '@/v2/plugins/axios';

const API_PATH = '/v1/whatsapp/analytics/main/data';

export class AnalyticsEntity {
	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
	}

	static fetchMainStatistics = async (params) => {
		try {
			const { data: responseData } = await api.get('/v1/whatsapp/analytics/main/data', {
				params,
			});
			const { result } = responseData;

			return result;
		} catch (e) {
			console.log(e);
		}
	};

	static fetchConversationsStatistics = async (params) => {
		try {
			const { data: responseData } = await api.get('/v1/whatsapp/analytics/conversation/data', {
				params,
			});
			const { result } = responseData;

			return result;
		} catch (e) {
			console.log(e);
		}
	};

	static fetchMessagesStatistics = async (params) => {
		try {
			const { data: responseData } = await api.get('/v1/whatsapp/analytics/message/data', {
				params,
			});
			const { result } = responseData;

			return result;
		} catch (e) {
			console.log(e);
		}
	};
}
